import { render, staticRenderFns } from "./EmailComplianceModal.vue?vue&type=template&id=5aeee55c&scoped=true"
import script from "./EmailComplianceModal.vue?vue&type=script&lang=js"
export * from "./EmailComplianceModal.vue?vue&type=script&lang=js"
import style0 from "./EmailComplianceModal.vue?vue&type=style&index=0&id=5aeee55c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeee55c",
  null
  
)

export default component.exports